<template>
    <div class='quetationOrder'>
        <div class="opera-group">
            <a-row>
                <a-col :span="4" style="margin:0 20px;">
                    <a-input v-model="form.projectName" placeholder="项目名称"/>
                </a-col>
                <a-col :span="9" style="display:flex;margin-right:20px">
                   <a-date-picker
                        v-model="startValue"
                        :disabled-date="disabledStartDate"
                        show-time
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="开始日期"
                          style="margin-right:20px;"
                        @openChange="handleStartOpenChange"
                        />
                     <a-date-picker
                        v-model="endValue"
                        :disabled-date="disabledEndDate"
                        show-time
                        format="YYYY-MM-DD HH:mm:ss"
                        placeholder="结束日期"
                        :open="endOpen"
                        @openChange="handleEndOpenChange"
                        />
                </a-col>
                <a-col :span="4" style="margin-right:20px;">
                    <a-select style="width: 100%"  v-model="form.invoiceStatus" placeholder="请选择是否开票">
                        <a-select-option value="1">未开票</a-select-option>
                        <a-select-option value="0">已开票</a-select-option>
                    </a-select>
                </a-col>
                 <a-col :span="4" style="margin-right:20px;">
                    <a-select style="width: 100%" v-model="form.processState" placeholder="请选择状态">
                        <a-select-option value="0">待支付首款</a-select-option>
                        <a-select-option value="1">首款待审核</a-select-option>
                        <a-select-option value="2">待签署合同</a-select-option>
                        <a-select-option value="3">待支付尾款</a-select-option>
                        <a-select-option value="4">尾款待审核</a-select-option>
                        <a-select-option value="5">待验收</a-select-option>
                        <a-select-option value="6">已完成</a-select-option>
                        <a-select-option value="7">已取消</a-select-option>
                    </a-select>
                </a-col>
            </a-row>   
            <a-row style="padding:20px 0 20px 20px">
                 <a-button type="primary" @click="search()" style="margin-right:20px;">查询</a-button></a-button>
                 <a-button type="primary" @click="clear()">重置</a-button>
            </a-row>    
            <div class="manage-table">
                <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="false"  :rowKey="(record,index)=>{return index}" >
                    <span slot="orderNo" slot-scope="text">{{ text || '暂无' }}</span>
                   
                    <span slot="pickupTime" slot-scope="text">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span> {{ text }}</span>
                            </template>
                            {{ text }}
                        </a-tooltip> 
                    </span>
                    <span slot="projectName" slot-scope="text">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span> {{ text }}</span>
                            </template>
                            {{ text }}
                        </a-tooltip> 
                    </span>
                    <span slot="quotationPrice" slot-scope="text">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span> {{ text }}万元</span>
                            </template>
                            {{ text }}万元
                        </a-tooltip> 
                    </span>
                    <span slot="margin" slot-scope="text">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span> {{ text }}万元</span>
                            </template>
                            {{ text }}万元
                        </a-tooltip> 
                    </span>
                    <template slot="action" slot-scope="text,record">
                        <div class="operate-btns">
                            <a-button v-if="record.processState=='0'" type="primary" @click="uplpadPayment(record)">首款支付凭证</a-button>
                            <a-button v-if="record.processState=='3'" type="primary" @click="uplpadPayment(record)">尾款支付凭证</a-button>
                            <a-button type="primary" @click="cancelOrder(record)" v-if="record.isok && record.processState!='7' && record.processState=='0'" style="margin-left:10px;">撤单</a-button>
                            <a-button type="primary" style="margin-left:10px;" v-if="record.buyerComplaint=='0'" @click="complaint(record)">申诉</a-button>
                        </div>
                    </template>
                </a-table>
            </div>    
            <pagination ref="pagination" :current="params.pageNum" :total="total" @getList="getList"></pagination> 
        </div> 
        <maindialog ref="maindialog" @getList="search"></maindialog>
        <complaint ref="complaint" @setlist="search"></complaint>
    </div>    
</template>
<script>
const columns = [
    {
      title: '订单编号',
      dataIndex: 'orderNo',
      width:180,
      scopedSlots: { customRender: 'orderNo' },
      ellipsis: true,
    },
    {
      title: '项目名称',
      dataIndex: 'projectName',
      width:100,
      scopedSlots: { customRender: 'projectName' },
    },
    {
      title: '成交价',
      dataIndex: 'quotationPrice',
      width:100,
      scopedSlots: { customRender: 'quotationPrice' },
    },
    {
      title: '流转保证金',
      dataIndex: 'margin',
      width:100,
       scopedSlots: { customRender: 'margin' },
    },
    {
      title: '出让方名称',
      dataIndex: 'sellerName',
      width:100
    },
    {
      title: '状态',
      dataIndex: 'processName',
      width: 100
    },
    {
      title: '下单时间',
      dataIndex: 'pickupTime',
      width: 140,
      scopedSlots: { customRender: 'pickupTime' },
    },
    {
      title: '操作',
      fixed: 'right',
      id:'8',
      dataIndex: 'operate',
      width: 300,
      scopedSlots: { customRender: 'action' },
    },
]
import maindialog from '@/views/BuyerCenter/buyer-gp/components/maindialog'
export default {
    components:{
        maindialog
    },
    data(){
        return{
            columns:columns,
            form:{
                projectName:'',
                startPickUpTime:'',
                endPickUpTime:'',
                invoiceStatus:undefined,
                processState:undefined,
                pageSize:10,
                pageNum:1
            },
            startValue: null,
            endValue: null,
            endOpen: false,
            loading:false,
            data:[],
            total:0,
            params:{
                pageSize:10,
                pageNum:1
            },
            currentId:''
        }
    },
    created(){
         this.getDataList()
    },
    mounted(){
        this.$parent.activeIndex = 1;
    },
    methods:{
        complaint(record){
            record = JSON.stringify(record);
            let complaintType = 0; //申诉类型(0挂牌 1竞价)
            let complaintObj = 0;//申诉对象(0 买家 1卖家)
            this.$refs.complaint.showDialog(record,complaintType,complaintObj);
        },
        disabledStartDate(startValue) {
            const endValue = this.endValue;
            if (!startValue || !endValue) {
                return false;
            }
            return startValue.valueOf() > endValue.valueOf();
        },
        disabledEndDate(endValue) {
            const startValue = this.startValue;
            if (!endValue || !startValue) {
                return false;
            }
            return startValue.valueOf() >= endValue.valueOf();
        },
        handleStartOpenChange(open) {
            if (!open) {
                this.endOpen = true;
            }
        },
        handleEndOpenChange(open) {
             this.endOpen = open;
        },
        search(){
            this.form.pageSize=10;
            this.form.pageNum=1;
            this.getDataList();
        },
        getList(page){
            this.params.pageNum = page;
            this.getDataList();
        },
        getDataList(){
            this.loading = true;
             if(this.startValue){
                this.form.startPickUpTime = this.$utils.formatDateMytime(this.startValue);
            }
            if(this.endValue){
               this.form.endPickUpTime = this.$utils.formatDateMytime(this.endValue)
            }
            this.$https.get('/portal/listing/selectBgOrderList',{params:this.form}).then(res=>{
               this.loading = false;
               if(res.code == 200){
                   res.rows.forEach(item=>{
                       item.isok = this.$utils.getMIns(item.pickupTime) 
                   })
                  this.data = res.rows;
                  //判断下单时间是否有30分钟
                  this.total = Number(res.total);
               }
            }).catch(error=>{
                this.loading = false;
            })
        },
        clear(){
            this.form = {
                projectName:'',
                startPickUpTime:'',
                endPickUpTime:'',
                invoiceStatus:undefined,
                processState:undefined
            };
            this.search();
        },
        customRequest(info){
           let formdata=new FormData();
            formdata.append("file",info.file);
            this.$https.post('/file/upload',formdata).then(res=>{
                if(res.code == 200){
                    this.uploadNote(res.data.url)
                }
            })
        },
        cancelOrder(row){
            if(!this.$utils.getMIns(row.pickupTime)){ //true 小于等于30分钟
                this.$message.error('当前时间已超时');
                return false;
            }
            let _this = this;
            this.$confirm({
                title: '确定撤销该订单?',
                content: '',
                onOk() {
                    _this.$https.post(`/portal/listing/cancelOrder`,{ orderId:row.id,quotationId:row.quotationId }).then(res=>{
                            if(res.code == 200){
                                _this.$message.success('撤单成功');
                                _this.search();
                            }
                    }).catch(error=>{
                            _this.$message.success('撤单失败');
                        })
                    },
                    onCancel() {},
                    });
        },
        uplpadPayment(row){
              row = JSON.stringify(row)
              this.$refs.maindialog.showDialog(row)
        }
    }
}
</script>
<style lang="less" scoped>

</style>